import { type FieldFunctionOptions, type Reference } from "@apollo/client";
import { type FieldMergeFunction } from "@apollo/client/cache/inmemory/policies";

import { type QueryGetMyLensesLensesArgs } from "../../../gql-generated/types";

export interface LensesReference {
    lensesList: Reference[];
}

export const mergeLenses: FieldMergeFunction<
    LensesReference,
    LensesReference,
    FieldFunctionOptions<
        Record<keyof QueryGetMyLensesLensesArgs, QueryGetMyLensesLensesArgs[keyof QueryGetMyLensesLensesArgs]>
    >
> = (existing, incoming, { args }: FieldFunctionOptions<QueryGetMyLensesLensesArgs>) => {
    if (!existing || !args || args.input.offset === 0) {
        return incoming;
    }
    const {
        input: { limit, offset },
    } = args;

    if (limit + offset === existing.lensesList.length) {
        return existing;
    }

    const { lensesList: prevLensesList } = existing;
    const { lensesList: newLensesList } = incoming;

    const merged = [...prevLensesList];

    for (let i = 0; i < newLensesList.length; ++i) {
        const reference = newLensesList[i];
        if (reference) {
            merged[offset + i] = reference;
        }
    }

    return { lensesList: merged };
};
